import React from 'react';
import ReactDOM from 'react-dom/client';

import 'virtual:svg-icons-register';

import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);
console.log('Test deployment - Fri Oct 31 18:24:14 CST 2025');
